var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('a',{attrs:{"href":_vm.url}},[_c('img',{staticClass:"inline-block h-full max-w-3xs max-h-16 object-contain",staticStyle:{"mix-blend-mode":"multiply"},attrs:{"src":_vm.img,"alt":_vm.alt}})])])}
var staticRenderFns = []

export { render, staticRenderFns }